import { useEffect, useState } from "react";

export default function CourierWorldMobileHome() {
  const sliderImages = [
    "/slider1.jpg",
    "/slider2.jpg",
    "/slider3.jpg",
    "/slider4.jpg",
    "/slider5.jpg",
    "/slider6.jpg",
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
    }, 6000);

    return () => clearInterval(timer);
  }, []);

  const services = [
    "We send parcels worldwide safely and quickly.",
    "Fast and reliable international delivery services.",
    "Secure handling with timely updates.",
  
  ];


  const servicee = [
    "Food & Essentials: Food items, snacks, pickles, sweets, medicines, and fabrics.",
    "Electronics: Safe delivery of laptops, mobiles, and other electronic goods.",
    "Documents & Valuables: Secure shipping for documents and important items.",
  
  ];

  return (
    <div className="min-h-screen bg-[#0d47c7] flex justify-center py-2 px-2">
      {/* Mobile frame centered even on desktop */}
      <div className="w-full max-w-[430px] bg-[#0d47c7] space-y-3">
        {/* Header */}
        <section className="bg-white rounded-[20px] p-4">
          <div className="flex items-center gap-3 text-[14px] text-black font-medium">
            <img
            src="/circle.png"
            alt="Courier icon"
            className="w-6 h-6 rounded-full object-cover"
            />
            <p>
              Courier Services <span className="font-bold">        </span>
            </p>
          </div>

          {/* leave image area exactly like your design */}
          <div className="mt-4 h-[86px] rounded-[18px] overflow-hidden bg-gray-200">
            <img
              src="/cwlogo.png"              
              alt="Top banner"
              className="w-full h-full object-cover"
            />
          </div>
        </section>

        {/* Square promo image slider */}
        <section className="bg-white rounded-[20px] p-3">
          <div
            className="w-full aspect-square rounded-[18px] overflow-hidden bg-gray-200 touch-pan-x"
            onTouchStart={(e) => {
              const startX = e.touches[0].clientX;
              e.currentTarget.dataset.startX = startX;
            }}
            onTouchEnd={(e) => {
              const startX = Number(e.currentTarget.dataset.startX || 0);
              const endX = e.changedTouches[0].clientX;
              const diff = startX - endX;
              if (diff > 50) {
                setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
              } else if (diff < -50) {
                setCurrentSlide((prev) =>
                  prev === 0 ? sliderImages.length - 1 : prev - 1
                );
              }
            }}
          >
            <img
              src={sliderImages[currentSlide]}
              alt={`Slide ${currentSlide + 1}`}
              className="w-full h-full object-cover transition-all duration-500"
            />
          </div>

          <div className="flex justify-center gap-2 mt-3">
            {sliderImages.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrentSlide(i)}
                className={`h-2 rounded-full transition-all ${
                  currentSlide === i ? "w-6 bg-blue-600" : "w-2 bg-gray-300"
                }`}
              />
            ))}
          </div>
        </section>

        {/* Home pickup */}
        <section className="rounded-[20px] bg-gradient-to-r from-purple-500 to-sky-400 p-4 flex gap-4 items-center">
  <img
    src="/Home pickup(red char).png"
    alt="Home pickup"
    className="w-[40%] h-[150px] object-cover rounded-[18px]"
  />

  <div className="flex-1 text-white text-right">
    <h2 className="text-[20px] font-extrabold uppercase leading-tight">
      Home Pick-up Service
    </h2>

    <p className="text-[15px] mt-2">
      Our agent will pack your items at your home.
    </p>

    <a href="tel:9959971831">
      <button className="mt-3 px-5 py-2 bg-white text-[#f48b8b] rounded-full text-[14px] font-semibold shadow-sm hover:scale-105 active:scale-95 transition">
        📞 Pick Up
      </button>
    </a>
  </div>
</section>



        {/* Packing */}
        <section className="rounded-[20px] bg-[#e9a90a] p-4 flex gap-4 items-center">
  <div className="flex-1 text-white">
    <h2 className="text-[20px] font-extrabold uppercase leading-tight">
      International Packing
    </h2>

    <p className="text-[15px] mt-2">
      We provide international courier packing services for abroad delivery.
    </p>

  </div>

  <img
    src="/packingimage.png"
    alt="Packing"
    className="w-[40%] h-[150px] object-cover rounded-[18px]"
  />
</section>


        {/* International & Domestic Services */}
<section className="bg-white rounded-[20px] p-5 space-y-4">
  <h2 className="text-[20px] font-bold text-[#123b99] leading-tight">
    International & Domestic Services
  </h2>

  <p className="text-[14px] text-[#123b99] leading-relaxed">
    Courier World provides reliable international and domestic courier services
    across Telangana and Andhra Pradesh. We deliver to countries like <b>USA, UK,
    Canada, Germany, Europe, Singapore, Australia, New Zealand, Dubai, France,</b>
    and UAE with speed and safety.
  </p>

  {/* small banner image (optional) */}
  <div className="w-full h-[120px] rounded-[16px] overflow-hidden bg-gray-200">
    <img
      src="/services-banner.png"
      alt="Courier services"
      className="w-full h-full object-cover"
    />
  </div>

  <div className="w-full h-[220px] rounded-[16px] overflow-hidden bg-gray-200">
    <img
      src="/worldmap.png"
      alt="Courier services"
      className="w-full h-full object-cover"
    />
  </div>


</section>

{/* Office Locations */}

         <h3 className="text-white text-[18px] font-bold uppercase px-2 mb-3 tracking-tight">
            Office Locations
          </h3>


<section className="bg-white rounded-[20px] p-5 space-y-4">
  <h2 className="text-[18px] font-bold text-[#123b99]">
    Office Locations
  </h2>

  <div className="grid grid-cols-2 gap-4">
    {/* Location Card 1 */}
    <div className="flex gap-3">
      <img
        src="/location.png"
        alt="Location"
        className="w-[50px] h-[50px] rounded-[12px] object-cover"
      />
      <div>
        <h4 className="text-[13px] font-bold text-[#123b99]">
          HANAMKONDA
        </h4>
        <p className="text-[12px] text-gray-600 leading-tight">
          Head office Branch
        </p>
      </div>
    </div>

    {/* Location Card 2 */}
    <div className="flex gap-3">
      <img
        src="/location.png"
        alt="Location"
        className="w-[50px] h-[50px] rounded-[12px] object-cover"
      />
      <div>
        <h4 className="text-[13px] font-bold text-[#123b99]">
          WARANGAL
        </h4>
        <p className="text-[12px] text-gray-600 leading-tight">
          Warangal Branch..
        </p>
      </div>
    </div>

     {/* Location Card 3 */}

    <div className="flex gap-3">
      <img
        src="/location.png"
        alt="Location"
        className="w-[50px] h-[50px] rounded-[12px] object-cover"
      />
      <div>
        <h4 className="text-[13px] font-bold text-[#123b99]">
          KARIMNAGAR
        </h4>
        <p className="text-[12px] text-gray-600 leading-tight">
          karimnagar Branch.....
        </p>
      </div>
    </div> 

    {/* Location Card 4 */}
    

    <div className="flex gap-3">
      <img
        src="/location.png"
        alt="Location"
        className="w-[50px] h-[50px] rounded-[12px] object-cover"
      />
      <div>
        <h4 className="text-[13px] font-bold text-[#123b99]">
          HYDERABAD
        </h4>
        <p className="text-[12px] text-gray-600 leading-tight">
          Hyderabad Branch.....
        </p>
      </div>
    </div> 
    
  </div>
</section>



        {/* Services */}
        <section>
          <h3 className="text-white text-[18px] font-bold uppercase px-2 mb-3 tracking-tight">
            Our Specialization
          </h3>
          <div className="bg-white rounded-[20px] p-5 text-[#123b99]">
            <ul className="space-y-3 text-[15px] leading-8">
              {services.map((item, i) => (
                <li key={i} className="font-medium">• {item}</li>
              ))}
            </ul>
          </div>
        </section>
        
        <section>
          <h3 className="text-white text-[18px] font-bold uppercase px-2 mb-3 tracking-tight">
            Our Services
          </h3>
          <div className="bg-white rounded-[20px] p-5 text-[#123b99]">
            <ul className="space-y-3 text-[15px] leading-8">
              {servicee.map((item, i) => (
                <li key={i} className="font-medium">• {item}</li>
              ))}
            </ul>
          </div>
        </section>

        {/* YouTube Video Section */}
<section>
  <h3 className="text-white text-[18px] font-bold uppercase px-2 mb-3 tracking-tight">
    Watch Our Video
  </h3>

  <div className="bg-white rounded-[20px] p-3 overflow-hidden shadow-lg">
    <div className="relative w-full pb-[56.25%] rounded-[18px] overflow-hidden">
      <iframe
        className="absolute top-0 left-0 w-full h-full"
        src="https://www.youtube.com/embed/22Ys5xOWmGY"
        title="Courier World Video"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  </div>
</section>

<section>
          <h3 className="text-white text-[10px] font-bold uppercase px-2 mb-3 tracking-tight">
            V2.2: 09-05-2026
          </h3>
         
        </section>



      </div>
    </div>
  );
}
